import { createFileRoute } from "@tanstack/react-router";
import { InvestorNetwork } from "@/components/InvestorNetwork";

function RouteComponent() {
  return <InvestorNetwork />;
}

export const Route = createFileRoute("/_authenticated/investor-network/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
